import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApolloProvider } from '@apollo/client/react';

import { Amplify } from 'aws-amplify';
import { I18nextProvider } from 'react-i18next';
import { PostHogProvider } from 'posthog-js/react';
import i18n from '@shared/config/i18Next';

import App from './components/App';
import { AppProvider } from './components/contexts/AppContext';
import client from './apolloClient';
import { isPostHogEnabled, posthogKey, posthogHost } from './config';
import { sanitizeEvent } from './analytics/sanitize';

Amplify.configure({
  Auth: {
    identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
    region: import.meta.env.VITE_AWS_REGION,
    userPoolId: import.meta.env.VITE_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false,
    federationTarget: 'COGNITO_USER_POOLS',
  },
});

const posthogOptions = {
  api_host: posthogHost,
  autocapture: true,
  capture_pageview: 'history_change',
  before_send: sanitizeEvent,
};

const renderApp = () => {
  const app = (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <AppProvider>
            <App />
          </AppProvider>
        </ApolloProvider>
      </BrowserRouter>
    </I18nextProvider>
  );

  if (!isPostHogEnabled) {
    return app;
  }

  return (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      {app}
    </PostHogProvider>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(renderApp());
